var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSelectBoxMultiple = function SvgSelectBoxMultiple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#335CFF",
    d: "M5.5 5V2.6a.6.6 0 0 1 .6-.6h7.8a.6.6 0 0 1 .6.6v7.8a.6.6 0 0 1-.6.6h-2.4v2.396c0 .333-.27.604-.604.604H3.104a.604.604 0 0 1-.604-.604l.002-7.792c0-.333.27-.604.604-.604zm1.2 0h4.196c.333 0 .604.27.604.604V9.8h1.8V3.2H6.7zM3.702 6.2 3.7 12.8h6.6V6.2z"
  })));
};
export default SvgSelectBoxMultiple;